import { KEYS, repository } from '@repositories/Repository';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import type IProductRelationsRepository from '@repositories/productsRelationsRepository/IProductRelationsRepository';
import { ProductRelationDetailModel } from '@repositories/productsRelationsRepository/models/ProductRelationDetailModel';

const productRelationsRepository = repository.get<IProductRelationsRepository>(KEYS.PRODUCT_RELATIONS_REPOSITORY);

const queryKey = {
  all: ['productRelations'] as const,
  one: (productId: SoftwareId) => [...queryKey.all, productId] as const,
};

export const useGetProductRelations = (productId: string) => {
  const result = useQuery<ProductRelationDetailModel[], AxiosError>(queryKey.one(productId), async () => {
    const result = await productRelationsRepository.getOne(productId);
    return result.map(dto => new ProductRelationDetailModel(dto));
  });

  return { data: result.data ?? [] };
};
